module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    staticClass: "teal lighten-4",
    attrs: {
      "top-navbar": "",
      "footer": "",
      "left-fixed-sidebar": ""
    }
  }, [_c('header', [_c('app-nav')], 1), _vm._v(" "), _c('main', {
    staticClass: "clearfix"
  }, [_c('v-sidebar', {
    attrs: {
      "drawer": "",
      "items": _vm.itemsGroup,
      "id": "mainsidebar"
    }
  }), _vm._v(" "), _c('v-content', [_c('transition', {
    attrs: {
      "name": "slide",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1), _vm._v(" "), _c('v-footer', [_c('div', [_vm._v(" </> with zZz")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-196c0206!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 80
// module chunks = 1